export default "__VITE_ASSET__Bf7HoiqI__"